import styled from "@emotion/styled";

export const StyledButtonGroup = styled.div<{ $orientation: "horizontal" | "vertical" }>`
  display: flex;
  flex-direction: ${({ $orientation }) => ($orientation === "horizontal" ? "row" : "column")};
  gap: ${({ theme }) => theme.spacing["2"]};
`;
